import palette from './palette';
import colours from './colours';
import shadows from './shadows';
import layout from './layout';
import typography from './typography';
import zIndex from './z-index';
import overrides from './overrides';

export default {
  palette,
  colours,
  shadows,
  layout,
  typography,
  zIndex,
  overrides
};



// WEBPACK FOOTER //
// ./styles/default-theme/index.js